import type {DIContainerFactory} from './containerFactories/types';

export class Module<T = unknown> {
  constructor(
    readonly id: string,
    readonly containerFactory: DIContainerFactory,
    readonly exports: T,
  ) {}
}
